<template>
  <div>
    <DialogBottomSheet
      :is-visible="isDialogOpened"
      :width="isMobile ? undefined : 375"
      content-class="rounded-0"
      @input="filtersStore.resetUnsavedFilters"
      @dialog-bottom-sheet:change-visible="closeDialog"
    >
      <v-card
        tile
        class="pt-6 px-4 pb-4"
      >
        <div class="text-h6 mb-2">
          {{ t('Время работы', options) }}
        </div>
        <TimeWorkSelector
          v-model="filtersStore.unsavedFilters"
        />
        <BtnApplyFilters
          class="mt-4"
          :active="isDialogOpened"
          :trigger-request="triggerUpdateLpuCount"
          @click:submit="applySelectedTimeWork"
          @click:close="closeDialog"
        />
      </v-card>
    </DialogBottomSheet>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import I18NextVue from 'i18next'
import { dispatchCustomEventGlobally, debounce } from 'www/utils'
import DialogBottomSheet from 'www/vue_components/common/core/DialogBottomSheet.vue'
import useChipsStore from 'www/vue_components/common/TheFilters/lpu/stores/useChipsStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import updateLpuListPage from 'www/vue_components/common/TheFilters/lpu/functions/updateLpuListPage'
import getTimeWorkLabel from 'www/vue_components/common/TheFilters/lpu/components/TimeWorkFilters/functions/getTimeWorkLabel'
import BtnApplyFilters from 'www/vue_components/common/TheFilters/lpu/components/BtnApplyFilters/BtnApplyFilters.vue'
import TimeWorkSelector from 'www/vue_components/common/TheFilters/lpu/components/TimeWorkFilters/components/TimeWorkSelector/TimeWorkSelector.vue'
import { EVENTS as SNACKBAR_EVENTS } from 'www/vue_components/common/core/SnackbarNotification/constants'

const chipsStore = useChipsStore()
const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('TimeWorkFilters')

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const isMobile = window.MOBILE_VERSION

watch(
  () => filtersStore.filters.timeWork,
  () => {
    const name = getTimeWorkLabel({
      timeWork: filtersStore.filters.timeWork,
    })

    chipsStore.updateWorkTimeChip({
      name: name || t('Открыто сейчас', options.value),
      isActive: filtersStore.filters.timeWork.type !== 'any',
      isVisible: true,
      onClick: async () => {
        if (!name) {
          filtersStore.updateFilters({
            timeWork: { type: 'open_now' },
          })

          await updateLpuListPage()

          return
        }

        openDialog()
      },
      onReset: async () => {
        filtersStore.updateFilters({
          timeWork: { type: 'any' },
        })

        await updateLpuListPage()

        dispatchCustomEventGlobally(SNACKBAR_EVENTS.open, {
          upper: true,
          message: t('Фильтр сброшен', options.value),
        })
      },
    })
  },
  { immediate: true },
)

const triggerUpdateLpuCount = ref(false)

const updateLpuCount = () => {
  triggerUpdateLpuCount.value = !triggerUpdateLpuCount.value
}
const debouncedUpdateLpuCount = debounce(updateLpuCount, 500)

watch(() => filtersStore.unsavedFilters.timeWork, (newVal, oldVal) => {
  if (newVal.type === 'custom' && oldVal.type === 'custom' && newVal.weekday === oldVal.weekday) {
    debouncedUpdateLpuCount()
  } else {
    updateLpuCount()
  }
}, { deep: true })

const applySelectedTimeWork = async () => {
  closeDialog()
  filtersStore.applyUnsavedFilters()
  await updateLpuListPage()
}
</script>
